<div class="form-group">
  <label class="form-group__label">
    <input
      (click)="switch(elementValue)"
      type="radio"
      [name]="name"
      class="form-group__label__switch-input"
      [checked]="elementValue == value"
    />
    <span class="form-group__label__text">{{ label }}</span>
    <span class="form-group__label__checkmark"></span>
  </label>
</div>
